(function($, Drupal, once) {

  Drupal.behaviors.nasstar_scripts = {
    attach: function (context, settings) {

      $(document).ready(function(){
        let swiperInstance = null;

        function setCustomerStoryHeight() {
          let maxHeight = 0;
          $('.swiper-slide').each(function() {
            if ($(this).outerHeight() > maxHeight)
              maxHeight = $(this).outerHeight();
          });
          $('.swiper-slide').css('height', maxHeight);
        }

        function customerStoriesSwiper() {
          setCustomerStoryHeight();

          const windowWidth = window.innerWidth;
          const swipeContainerClass = '.customer-stories-swipe-container';
          const swipeClass = '.swiper-slide';

          // Destroy the existing instance if it exists
          if (swiperInstance instanceof Swiper) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;

            // Reset the styles for the swiper-container and swiper-slide
            const swiperContainer = document.querySelector(swipeContainerClass);
            const swiperSlides = document.querySelectorAll(swipeClass);

            if (swiperContainer) {
              swiperContainer.removeAttribute("style");
            }

            swiperSlides.forEach((slide) => {
              slide.removeAttribute("style");
            });
          }

          // Initialize Swiper based on the window width
          if (windowWidth > 1000 && windowWidth <= 1240) {
            swiperInstance = new Swiper('.customer-stories-swipe-container', {
              direction: "horizontal",
              slidesPerView: 2,
              loop: true,
              spaceBetween: 16,
            });
          } else if (windowWidth <= 999) {
            swiperInstance = new Swiper('.customer-stories-swipe-container', {
              direction: "horizontal",
              slidesPerView: 1,
              loop: true,
              spaceBetween: 16,
            });
          }
        }

        // Return if already initialised
        if ($('.customer-stories-swipe-container').attr('data-initialised') !== undefined)
          return;

        // Mark as initialised
        $('.customer-stories-swipe-container').attr('data-initialised', true);

        // Initialise the
        customerStoriesSwiper();

        // Initialise the customer stories swiper on resize
        $(window).on("resize", function () {
          customerStoriesSwiper();
        });
      });

    }
  }

})(jQuery, Drupal, once)




